import { SaveSkillBranchDto, SkillBranchDict } from "../../../../model/Dto/Dict/Skill";
import { ApiRequest, RequestMethod } from "../../../request";

export async function updateSkillBranch(id: string, data: SaveSkillBranchDto): Promise<SkillBranchDict | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(`/api/skill-branch/${id}`);
    apiRequest.setJsonBody(data);
    const response: any = await apiRequest.send();
    return response.status === 200 ? response.data : null;
}
